import { render, staticRenderFns } from "./ArticlesRight.vue?vue&type=template&id=75d99a56&scoped=true&"
import script from "./ArticlesRight.vue?vue&type=script&lang=js&"
export * from "./ArticlesRight.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesRight.vue?vue&type=style&index=0&id=75d99a56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d99a56",
  null
  
)

export default component.exports